// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsed {
  max-width: 3.5rem !important;
  min-width: 3.5rem !important;
}

.collapsed-badge {
  position: absolute;
  top: 4px;
  right: 10px;
  padding: 3px 3px;
  font-size: 0.7rem;
}

.avatar {
  height: 2rem;
  width: 2rem;
}

.menu-icon {
  margin-right: 1rem;
  color: white;
}

.menu-add-sale-btn {
  margin-left: auto;
  margin-right: 0;
  --color: white;
  --padding-start: 4px;
  --padding-end: 0;
  min-height: 28px;
}
.menu-add-sale-btn ion-icon {
  font-size: 1.25rem;
}
.menu-add-sale-btn:hover {
  --color: var(--ion-color-primary);
}

@media screen and (min-width: 992px) {
  ion-menu {
    max-width: 272px;
  }
}
ion-content {
  --background: var(--ion-color-darkgrey);
}
@media (prefers-color-scheme: dark) and (max-width: 0) {
  ion-content {
    --background: var(--ion-background-color);
  }
}

ion-list {
  padding-top: 0;
  padding-bottom: 0;
}

ion-item {
  --background: var(--ion-color-darkgrey);
  color: white;
  --min-height: 1rem;
  padding: 0;
  border: none;
  border-radius: 0;
}
ion-item:hover {
  cursor: pointer;
  --background: var(--ion-color-darkgrey-tint);
}
@media (prefers-color-scheme: dark) and (max-width: 0) {
  ion-item {
    --background: var(--ion-background-color);
  }
}

ion-item.smr-no-hover:hover {
  cursor: default;
  --background: var(--ion-color-darkgrey);
}
@media (prefers-color-scheme: dark) and (max-width: 0) {
  ion-item.smr-no-hover:hover {
    --background: var(--ion-background-color);
  }
}

ion-toolbar {
  --background: var(--ion-color-darkgrey-333);
}
@media (prefers-color-scheme: dark) and (max-width: 0) {
  ion-toolbar {
    --background: var(--ion-background-color);
  }
}

.user-info {
  --background: var(--ion-color-darkgrey-333);
  --color: white;
  --width: 100%;
}
@media (prefers-color-scheme: dark) and (max-width: 0) {
  .user-info {
    --background: var(--ion-background-color);
  }
}

.user-name {
  font-weight: bold;
}

.user-role {
  color: grey;
}

ion-title {
  padding-left: 0;
}

ion-menu-toggle {
  display: block;
  height: 2.2rem;
}

ion-icon {
  font-size: 20px;
}

.smr-menu-item ion-label {
  display: flex;
  justify-content: left;
  align-content: center;
}

.smr-menu-item {
  min-height: 2.2rem;
  font-size: 0.95rem;
}
.smr-menu-item:hover {
  cursor: pointer;
  color: var(--ion-color-medium);
}
.smr-menu-item:hover ion-label {
  color: var(--ion-color-medium);
}

.sm-version-info {
  cursor: pointer;
  color: #666;
  margin-top: 20px;
  margin-bottom: 40px;
  text-align: left;
  display: block;
  width: 100%;
}
.sm-version-info ion-icon {
  color: #666;
}
.sm-version-info ion-icon:hover {
  color: #fff;
}
.sm-version-info:hover {
  color: #fff !important;
}

.expanded-item {
  --background: #6d6d6d;
}

ion-popover {
  --backdrop-opacity: 0;
  --offset-x: 20px;
  --offset-y: 10px;
}

ion-popover ion-content {
  --color: var(--ion-color-light);
  --background: var(--ion-color-darkgrey);
}

ion-icon {
  display: block !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,4BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,iCAAA;AAEJ;;AAEA;EACE;IACE,gBAAA;EACF;AACF;AAEA;EACE,uCAAA;AAAF;AACE;EAFF;IAGI,yCAAA;EAEF;AACF;;AACA;EACE,cAAA;EACA,iBAAA;AAEF;;AACA;EACE,uCAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAEF;AADE;EACE,eAAA;EACA,4CAAA;AAGJ;AADE;EAXF;IAYI,yCAAA;EAIF;AACF;;AAAE;EACE,eAAA;EACA,uCAAA;AAGJ;AAFI;EAHF;IAII,yCAAA;EAKJ;AACF;;AADA;EACE,2CAAA;AAIF;AAHE;EAFF;IAGI,yCAAA;EAMF;AACF;;AAAA;EACE,2CAAA;EACA,cAAA;EACA,aAAA;AAGF;AAFE;EAJF;IAKI,yCAAA;EAKF;AACF;;AAFA;EACE,iBAAA;AAKF;;AAFA;EACE,WAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,cAAA;EACA,cAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,kBAAA;AAKF;AAJE;EACE,eAAA;EACA,8BAAA;AAMJ;AAJI;EACE,8BAAA;AAMN;;AADA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAIF;AAHE;EACE,WAAA;AAKJ;AAJI;EACE,WAAA;AAMN;AAHE;EACE,sBAAA;AAKJ;;AADA;EACE,qBAAA;AAIF;;AADA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AAIF;;AADA;EACE,+BAAA;EACA,uCAAA;AAIF;;AADA;EACE,yBAAA;AAIF","sourcesContent":[".collapsed {\n  max-width: 3.5rem !important;\n  min-width: 3.5rem !important;\n}\n\n.collapsed-badge {\n  position: absolute;\n  top: 4px;\n  right: 10px;\n  padding: 3px 3px;\n  font-size: 0.7rem;\n}\n\n.avatar {\n  height: 2rem;\n  width: 2rem;\n}\n\n.menu-icon {\n  margin-right: 1rem;\n  color: white;\n}\n\n.menu-add-sale-btn {\n  margin-left: auto;\n  margin-right: 0;\n  --color: white;\n  --padding-start: 4px;\n  --padding-end: 0;\n  min-height: 28px;\n  ion-icon {\n    font-size: 1.25rem;\n  }\n  &:hover {\n    --color: var(--ion-color-primary);\n  }\n}\n\n@media screen and (min-width: 992px) {\n  ion-menu {\n    max-width: 272px;\n  }\n}\n\nion-content {\n  --background: var(--ion-color-darkgrey);\n  @media (prefers-color-scheme: dark) and (max-width: 0) {\n    --background: var(--ion-background-color);\n  }\n}\n\nion-list {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\nion-item {\n  --background: var(--ion-color-darkgrey);\n  color: white;\n  --min-height: 1rem;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  &:hover {\n    cursor: pointer;\n    --background: var(--ion-color-darkgrey-tint);\n  }\n  @media (prefers-color-scheme: dark) and (max-width: 0) {\n    --background: var(--ion-background-color);\n  }\n}\n\nion-item.smr-no-hover {\n  &:hover {\n    cursor: default;\n    --background: var(--ion-color-darkgrey);\n    @media (prefers-color-scheme: dark) and (max-width: 0) {\n      --background: var(--ion-background-color);\n    }\n  }\n}\n\nion-toolbar {\n  --background: var(--ion-color-darkgrey-333);\n  @media (prefers-color-scheme: dark) and (max-width: 0) {\n    --background: var(--ion-background-color);\n  }\n}\n\n.user-info-container {\n}\n\n.user-info {\n  --background: var(--ion-color-darkgrey-333);\n  --color: white;\n  --width: 100%;\n  @media (prefers-color-scheme: dark) and (max-width: 0) {\n    --background: var(--ion-background-color);\n  }\n}\n\n.user-name {\n  font-weight: bold;\n}\n\n.user-role {\n  color: grey;\n}\n\nion-title {\n  padding-left: 0;\n}\n\nion-menu-toggle {\n  display: block;\n  height: 2.2rem;\n}\n\nion-icon {\n  font-size: 20px;\n}\n\n.smr-menu-item ion-label {\n  display: flex;\n  justify-content: left;\n  align-content: center;\n}\n\n.smr-menu-item {\n  min-height: 2.2rem;\n  font-size: 0.95rem;\n  &:hover {\n    cursor: pointer;\n    color: var(--ion-color-medium);\n\n    ion-label {\n      color: var(--ion-color-medium);\n    }\n  }\n}\n\n.sm-version-info {\n  cursor: pointer;\n  color: #666;\n  margin-top: 20px;\n  margin-bottom: 40px;\n  text-align: left;\n  display: block;\n  width: 100%;\n  ion-icon {\n    color: #666;\n    &:hover {\n      color: #fff;\n    }\n  }\n  &:hover {\n    color: #fff !important;\n  }\n}\n\n.expanded-item {\n  --background: #6d6d6d;\n}\n\nion-popover {\n  --backdrop-opacity: 0;\n  --offset-x: 20px;\n  --offset-y: 10px;\n}\n\nion-popover ion-content {\n  --color: var(--ion-color-light);\n  --background: var(--ion-color-darkgrey);\n}\n\nion-icon {\n  display: block !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
